// https://medium.com/@martinseanhunt/how-to-invalidate-cached-data-in-apollo-and-handle-updating-paginated-queries-379e4b9e4698
function removeFromCache(cache, pattern) {
  const { data } = cache.data;
  Object
    .keys(data)
    .forEach(key => key.startsWith(`$ROOT_QUERY.${pattern}`) && cache.data.delete(key));
}

export default removeFromCache;
